import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfAppAveragesSummaryApplicationService } from '../../../core/application/services/scores/get-self-app-averages-summary.application-service';
import { SelfAppAverageSummaryEntity } from '../../../core/domain/entities/scores/self-app-average-summary.entity';
import { GetSelfAppAveragesSummaryRequestDto } from '../../dtos/scores/get-self-app-averages-summary.request.dto';

export class GetSelfAppAveragesSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfAppAveragesSummaryApplicationService
  ) {}
  async execute(
    props: GetSelfAppAveragesSummaryRequestDto
  ): Promise<SelfAppAverageSummaryEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
